import { render, staticRenderFns } from "./AsnDetailQuery.vue?vue&type=template&id=66b28034"
import script from "./AsnDetailQuery.vue?vue&type=script&lang=js"
export * from "./AsnDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports